import React from 'react'

class SocialShareWhite extends React.Component {
    render() {
        return (
            <div className="social-share">
                <ul>
                    <li>
                        <a href="https://www.facebook.com/sketchize/" target="_blank" rel="noopener noreferrer">
                            <span className="sketch-facebook-white"></span>
                        </a>
                    </li>
                    <li>
                        <a href="https://twitter.com/sketchizedesign" target="_blank" rel="noopener noreferrer">
                            <span className="sketch-twitter-white"></span>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/sketchize/" target="_blank" rel="noopener noreferrer">
                            <span className="sketch-instagram-white"></span>
                        </a>
                    </li>
                    <li>
                        <a href="https://github.com/selfishprimate/sketchize" target="_blank" rel="noopener noreferrer">
                            <span className="sketch-github-white"></span>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/sketchize/" target="_blank" rel="noopener noreferrer">
                            <span className="sketch-linkedin-white"></span>
                        </a>
                    </li>
                </ul>
            </div>
        )
    }
}

class SocialShareBlack extends React.Component {
    render() {
        return (
            <div className="social-share">
                <ul>
                    <li>
                        <a href="https://www.facebook.com/sketchize/" target="_blank" rel="noopener noreferrer">
                            <span className="sketch-facebook-black"><span className="path1"></span><span className="path2"></span></span>
                        </a>
                    </li>
                    <li>
                        <a href="https://twitter.com/sketchizedesign" target="_blank" rel="noopener noreferrer">
                            <span className="sketch-twitter-black"><span className="path1"></span><span className="path2"></span></span>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/sketchize/" target="_blank" rel="noopener noreferrer">
                            <span className="sketch-instagram-black"><span className="path1"></span><span className="path2"></span></span>
                        </a>
                    </li>
                    <li>
                        <a href="https://github.com/selfishprimate/sketchize" target="_blank" rel="noopener noreferrer">
                            <span className="sketch-github-black"><span className="path1"></span><span className="path2"></span></span>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/sketchize/" target="_blank" rel="noopener noreferrer">
                            <span className="sketch-linkedin-black"><span className="path1"></span><span className="path2"></span></span>
                        </a>
                    </li>
                </ul>
            </div>
        )
    }
}

export { SocialShareWhite, SocialShareBlack };



// WEBPACK FOOTER //
// ./src/components/SocialShare/SocialShare.js